// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__HWInb","row":"styles_row__KvlRC","content":"styles_content__wPNke","btns":"styles_btns__BMl1l","image":"styles_image__J72hU"};